import { getCookieConsentValue } from '@/helpers/CookieConsent';

const FACEBOOK_PIXEL_ID = process.env.VUE_APP_FACEBOOK_PIXEL_ID || null;
const FACEBOOK_PIXEL_SCRIPT_ID = 'facebook-pixel-script';

let facebookPixelLoaded = false;

const deleteCookie = (name) => {
	if (typeof window === 'undefined' || typeof document === 'undefined') {
		return;
	}

	const hostnameParts = window.location.hostname.split('.');
	const domains = [
		window.location.hostname,
		`.${window.location.hostname}`,
		hostnameParts.length > 2 ? `.${hostnameParts.slice(1).join('.')}` : null,
	].filter(Boolean);

	const expire = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/; SameSite=Lax`;
	document.cookie = expire;
	domains.forEach((domain) => {
		document.cookie = `${expire}; Domain=${domain}`;
	});
};

const deleteFacebookPixelCookies = () => {
	deleteCookie('_fbp');
	deleteCookie('_fbc');
};

const hasSessionStorage = () => {
	return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
};

export const FacebookPixelService = {
	load() {
		if (!FACEBOOK_PIXEL_ID || typeof window === 'undefined' || typeof document === 'undefined') {
			return;
		}

		if (facebookPixelLoaded) {
			return;
		}

		if (!window.fbq) {
			const fbq = function() {
				if (fbq.callMethod) {
					fbq.callMethod.apply(fbq, arguments);
				} else {
					fbq.queue.push(arguments);
				}
			};

			window.fbq = fbq;
			window._fbq = fbq;
			fbq.push = fbq;
			fbq.loaded = true;
			fbq.version = '2.0';
			fbq.queue = [];
		}

		if (!document.getElementById(FACEBOOK_PIXEL_SCRIPT_ID)) {
			const script = document.createElement('script');
			script.id = FACEBOOK_PIXEL_SCRIPT_ID;
			script.async = true;
			script.src = 'https://connect.facebook.net/en_US/fbevents.js';
			document.head.appendChild(script);
		}

		window.fbq('consent', 'grant');
		window.fbq('init', FACEBOOK_PIXEL_ID);
		window.fbq('track', 'PageView');
		facebookPixelLoaded = true;
	},

	unload() {
		if (typeof window === 'undefined' || typeof document === 'undefined') {
			return;
		}

		if (typeof window.fbq === 'function') {
			window.fbq('consent', 'revoke');
		}

		facebookPixelLoaded = false;

		const script = document.getElementById(FACEBOOK_PIXEL_SCRIPT_ID);
		if (script) {
			script.remove();
		}

		delete window.fbq;
		delete window._fbq;
		deleteFacebookPixelCookies();
	},

	syncWithConsent(cookiesAccepted) {
		if (cookiesAccepted === true) {
			this.load();
			return;
		}

		if (cookiesAccepted === false) {
			this.unload();
		}
	},

	track(eventName, payload = null) {
		if (!FACEBOOK_PIXEL_ID || getCookieConsentValue() !== true || typeof window === 'undefined') {
			return false;
		}

		this.load();

		if (typeof window.fbq !== 'function') {
			return false;
		}

		if (payload && Object.keys(payload).length > 0) {
			window.fbq('track', eventName, payload);
		} else {
			window.fbq('track', eventName);
		}

		return true;
	},

	trackOnce(storageKey, eventName, payload = null) {
		if (storageKey && hasSessionStorage() && window.sessionStorage.getItem(storageKey) === '1') {
			return false;
		}

		const tracked = this.track(eventName, payload);

		if (tracked && storageKey && hasSessionStorage()) {
			window.sessionStorage.setItem(storageKey, '1');
		}

		return tracked;
	},
};
